<template>
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
  >
    <path d="M2.5 0C1.67157 0 1 0.671573 1 1.5V5.5C1 6.32843 1.67157 7 2.5 7H9.5C10.3284 7 11 6.32843 11 5.5V1.5C11 0.671573 10.3284 0 9.5 0H2.5ZM2 1.5C2 1.22386 2.22386 1 2.5 1H9.5C9.77614 1 10 1.22386 10 1.5V5.5C10 5.77614 9.77614 6 9.5 6H2.5C2.22386 6 2 5.77614 2 5.5V1.5ZM0.5 8C0.223858 8 0 8.22386 0 8.5C0 8.77614 0.223858 9 0.5 9H11.5C11.7761 9 12 8.77614 12 8.5C12 8.22386 11.7761 8 11.5 8H0.5Z" />
  </svg>
</template>
